import LoginForm from "../components/login/login-form";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import LogoComponent from "../components/logo-comp";
import PageBackground from "../components/background-component";
import SocialAuthButtons from "../components/SocialAuthButtons"; // added

const LoginPage = () => {
    const { t } = useTranslation();

    const handleSocialSuccess = (data: any) => {
        // data: { provider, token, profile }
        // store token or call your backend to establish a session
        localStorage.setItem('authToken', data.token);
        // redirect to app home (or call API to validate token)
        window.location.href = '/';
    };

    const handleSocialError = (err: any) => {
        console.error('Social login error', err);
        // show user friendly message here
    };

    return (
        <div className="pg-form pg-login page-bg">
            <div className="page-wrapper">
                <PageBackground
                    desktop={{
                    avif: `${process.env.PUBLIC_URL}/img/page-bg-login.avif`,
                    webp: `${process.env.PUBLIC_URL}/img/page-bg-login.webp`,
                    jpg: `${process.env.PUBLIC_URL}/img/page-bg-login.jpg`
                    }}
                    mobile={{
                    avif: `${process.env.PUBLIC_URL}/img/page-bg-login.avif`,
                    webp: `${process.env.PUBLIC_URL}/img/page-bg-login.webp`,
                    jpg: `${process.env.PUBLIC_URL}/img/page-bg-login.jpg`
                    }}
                />
                <Row className="mb-3">
                    <Col md="12" className="margin-0">
                        <div className='bl-form bl-form-bg'>
                            <LogoComponent logoColor="white" />
                            <h1>Material Hub</h1>
                            <h2>{t('forms.signin')}</h2>
                            <LoginForm />
                            {/* <SocialAuthButtons onSuccess={handleSocialSuccess} onError={handleSocialError} /> */}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default LoginPage;